import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'

import FlowManager from 'components/FlowManager'
import { getCustomerSegment } from 'modules/billing/selectors'
import { ONBOARDING_STEP_COUNT, DEMO_REQUEST_STEP_COUNT, BOT_STEP_COUNT } from '../constants'
import OnboardingPlaybookRoutes from './routes'

const STEP_TOTAL = ONBOARDING_STEP_COUNT + DEMO_REQUEST_STEP_COUNT + BOT_STEP_COUNT

const mapStateToProps = (state) => {
  return {
    segment: getCustomerSegment(state)
  }
}

class OnboardingPlaybookFlow extends PureComponent {
  render() {
    const { match, history, segment } = this.props
    return (
      <Fragment>
        <FlowManager steps={OnboardingPlaybookRoutes} stepTotal={STEP_TOTAL} stepOffset={ONBOARDING_STEP_COUNT} baseUrl={match.url} history={history} segment={segment} name='Playbook Onboarding'/>
      </Fragment>
    )
  }
}

export default connect(mapStateToProps, null)(OnboardingPlaybookFlow)



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/OnboardingPlaybookFlow/index.js